import requset from "./requset"

export function getGameList(params = {}) {
    // 拼接uid和token
    return requset({
        url: "/payWeb/getGameList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            channel_uid: localStorage.getItem("pay_pc_channelUid") || "",
            ...params
        }
    })
}

export function getServerList(params = {}) {
    return requset({
        url: "/payWeb/getServerList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            ...params
        }
    })
}

export function getRoleList(params = {}) {
    return requset({
        url: "/payWeb/getRoleList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            ...params
        }
    })
}

export function getAreaList(params) {
    return requset({
        url: "/payWeb/getAreaList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            ...params
        }
    })
}

export function getPaymentList(params) {
    return requset({
        url: "/payWeb/getPaymentList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            ...params
        }
    })
}

export function getProductList(params) {
    return requset({
        url: "/payWeb/getProductList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            ...params
        },
    })
}

export function postSubmitOrder(params) {
    return requset({
        url: "/payWeb/submitOrder",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            ...params
        },
    })
}

export function getOrderList(params) {
    return requset({
        url: "/payWeb/getOrderList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            channel_uid: localStorage.getItem("pay_pc_channelUid") || "",
            ...params
        }
    })
}

export function getHistoryList(params) {
    return requset({
        url: "/payWeb/getHistoryList",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            channel_uid: localStorage.getItem("pay_pc_channelUid") || "",
            ...params
        }
    })
}

export function getCoupon(params) {
    return requset({
        url: "/payWeb/getCoupon",
        method: "get",
        params: {
            uid: localStorage.getItem("pay_pc_uid"),
            token: localStorage.getItem("pay_pc_token"),
            ...params
        }
    })
}